'use strict';

bbw.service.MsgToHtmlSvc = Class({

    statics: {
        URL_REGEX: /(((https?:\/\/)|(www\.))[\w\d\-._~:/?#@!$&'*+,;=]+)/g
    },

    $inject: ['bbw.SmileySvc'],

    construct: function(smileySvc) {
        this._smileySvc = smileySvc;
    },

    msgToHtml: function(input, rawHtml) {
        input = '' + input;
        return this._smileySvc.textWithMarkersToHtml(
            this.urlify(
                rawHtml ? input : ngtk.tools.string.escapeHtml(input).replace(/\n/g, '<br>')
            )
        );
    },

    urlify: function(text) {
        return text.replace(bbw.service.MsgToHtmlSvc.URL_REGEX, function(url, b, c) {
            var href = (c === 'www.') ? 'http://' + url : url;
            return '<a href="' + ngtk.tools.string.escapeHtml(href) + '" target="_blank">' + ngtk.tools.string.escapeHtml(url) + '</a>';
        })
    }


});
